<template lang="pug">
.main-content
  //- .form-group
  //-   label.col-md-12 搬送装置型式
  //-   .col-md-12
  //-     el-input(type='text', value='', v-model='transportDeviceData.transportType')
  .form-group
    span.col-md-12 可搬重量
    //- el-button(type='primary', icon='el-icon-plus', size='mini', @click='addPayload')
    //- .col-md-12(v-for='(item, index) in transportDeviceData.payload', :key='index', :index='index', :item='item', :transportDeviceData='transportDeviceData')
    //-   el-input(type='text', value='', v-model='transportDeviceData.payload[key]', @blur='saveData()')
  .form-group
    label.col-md-12 テーブル間距離
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.tableDistance', @blur='saveData()')
  .form-group
    label.col-md-12 W ターンピッチ
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.pitch')
  .form-group
    label.col-md-12  Wターン回転速度
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.rSpeed')
  .form-group
    label.col-md-12 テーブル回転速度
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.tableSpeed')
  .form-group
    label.col-md-12 最大ワーク寸法:直径
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.maxWork.width')
  .form-group
    label.col-md-12 最大ワーク寸法:高さ
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.maxWork.height')
  .form-group
    label.col-md-12 モータ容量:W ターン
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.motorCapacity.wturn')
  .form-group
    label.col-md-12 モータ容量:テーブル
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.motorCapacity.table')
  .form-group
    label.col-md-12 位置繰り返し精度
    .col-md-12
      el-input(type='text', value='', v-model='transportDeviceData.accuracy')

</template>

<script>
export default {
  name: 'TransportDevice',
  data () {
    return {
    }
  },
  props: {
    transportDeviceData: Object
  },
  methods: {
    addPayload () {
      // console.log(this.formdata)
      this.transportDeviceData.payload.push('')
    },
    saveData: function () {
      console.log(this.transportDeviceData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/TransportDevice.vue